import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { Store } from "redux"

import { GlobalState } from "../../store"
import OldUIContext from "../../olduicontext"
import Footer from "./Footer"
import { receiveButtons, setIsLoading } from "./slice"
import { IButtonData } from "./index"
import { IOldUIContext } from "../../global"

interface OldUIInit {
    start: (
        element: HTMLElement | undefined | null,
        buttons: IButtonData[],
    ) => void
    setIsLoading: (isLoading: boolean) => void
}

const init = (
    store: Store<GlobalState>,
    oldUIContext: IOldUIContext,
): OldUIInit => {
    return {
        start: (
            element: HTMLElement | undefined | null,
            buttons: IButtonData[],
        ): void => {
            if (!element) {
                throw new Error("Element should have value")
            }

            store.dispatch(receiveButtons(buttons))

            const root = createRoot(element)
            root.render(
                <Provider store={store}>
                    <OldUIContext.Provider value={oldUIContext}>
                        <Footer />
                    </OldUIContext.Provider>
                </Provider>,
            )
        },
        setIsLoading: (isLoading: boolean): void => {
            store.dispatch(setIsLoading(isLoading))
        },
    }
}

export default init
